<template>
    <div>
        <TablesFormatsPartBoolean v-if="header.type == 'boolean'" :item="item" :header="header"/>
        <TablesFormatsPartObject v-if="header.type == 'object'" :item="item" :header="header"/>
        <TablesFormatsPartDate v-if="header.type == 'date'" :item="item" :header="header"/>
        <TablesFormatsPartDateTime v-if="header.type == 'datetime'" :item="item" :header="header"/>
        <TablesFormatsPartLike v-if="header.type == 'like'" :item="item" :header="header"/>
        <TablesFormatsPartEnvironment v-if="header.type == 'environment'" :item="item" :header="header"/>
    </div>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
    header: { type: Object, required: true },
    item: { type: Object, required: true },
})
</script>